import type { AssociatedUser } from '/business/shared/functions/types';

function getAssociatedUsersByInviteState(associatedUsers: AssociatedUser[], inviteState: string): AssociatedUser[] {
  return associatedUsers.filter((associatedUser) => associatedUser.invite_state === inviteState) || [];
}

export default getAssociatedUsersByInviteState;
